/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import Button from "../../../../../components/Layout/Button";
import UploadFileIcon from "../../../../../components/Svg/UploadFileIcon";
import Styles from "./styles";

function UploadFile({
  handleFileUpload,
  handleButtonChoose,
  fileInputRef,
  filename,
}) {
  return (
    <div style={Styles.container}>
      <Box style={Styles.box}>
        <p style={Styles.filename}>{filename}</p>
        <Box sx={Styles.uploadBox}>
          <UploadFileIcon />
          <input
            type="file"
            accept=".zip"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileUpload}
          />
          <Button onClick={handleButtonChoose}>Upload Zip File</Button>
        </Box>
      </Box>
    </div>
  );
}

export default UploadFile;
